import { Box } from '@everlywell/ui-kit';
import React from 'react';

import SubHeader from '../SubHeader';
import NavigationBarV2 from './../NavigationBarV2';

export const NEW_NAV_HEIGHT = ['73px', null, null, '89px'];

const HeaderContainer: React.FC = () => (
  <>
    <NavigationBarV2 />
    <Box zIndex="3">
      <SubHeader />
    </Box>
  </>
);

export default HeaderContainer;
